<template>
  <div>
    <form
        @submit.prevent="submitForm"
        class="ecommerce-form action-buttons-fixed"
        novalidate
    >
      <div class="row" v-if="Object.keys(settings).length">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-toggle-right"></i>
                  <h2 class="card-big-info-title">Postavke dostave</h2>
                  <p class="card-big-info-desc">Definirajte osnovne parametre.</p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Omogućeno lično preuzimanje iz prodavnice
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <toggle-button :width="65" :height="35" color="#47a447" v-model="settings.pickupInStoreSettingsEnabled"/>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Omogući besplatnu dostavu
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <toggle-button :width="65" :height="35" color="#47a447" v-model="settings.freeShippingEnabled"/>
                      </div>
                    </div>
                  </div>

                  <div 
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.settings.freeShippingOverXAmount.$anyError }"
                  >
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Besplatna dostava preko (KM)
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <input :disabled="!settings.freeShippingEnabled" type="number" class="form-control form-control-modern" v-model="settings.freeShippingOverXAmount"/>

                        <form-error
                          :model="$v.settings.freeShippingOverXAmount"
                          :dirty="$v.$dirty"
                          :label="translations.forms.labels.freeShippingOverXAmount"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Ograničenje maksimalne težine
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <toggle-button :width="65" :height="35" color="#47a447" v-model="settings.maximumWeightRestriction"/>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';
import { translations } from '@/mixins';
import api from '@/services/api';
import validations from "./validation-schema/shipping-settings";
import FormError from "@/components/shared/form-errors/FormError.vue";

export default {
  name: 'ShippingSettings',
  mixins: [translations],
  components: { ToggleButton, FormError },
  validations: {
    settings: validations
  },
  data() {
    return {
      key: 'ShippingSettings',
    };
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this.translations.forms.notValid);
        this.$nextTick(() => {
          let elem = document.querySelector('.has-danger');
          elem.scrollIntoView(true);
        });
        return;
      }

      api.updateSettings(this.key, this.settings).then((response) => {
        this.$toast.info(response.data.info);
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
  },
  computed: {
    settings() {
      return this.$store.getters.getSettings;
    },
  },
  mounted() {
    this.$store.dispatch('getSettings', this.key);
  },
  destroyed() {
    this.$store.commit('INIT_SETTINGS', {});
  },
};
</script>